import { Input } from "antd";
import { SearchOutlined } from "@ant-design/icons";

export default function Searchbar({
	placeholder,
	value,
	onChange,
	style,
	width,
}) {
	const isRTL = localStorage.getItem("lang") === "ar";
	return (
		<Input
			prefix={<SearchOutlined style={{ color: "#aaa" }} />}
			placeholder={placeholder}
			value={value}
			onChange={onChange}
			style={{
				width: style ? (width ? width : "350px") : "100%",
				direction: isRTL ? "rtl" : "ltr",
				borderRadius: "8px",
				// height: "40px",
			}}
		/>
	);
}
